import React, { useState } from 'react';
import './CTA.css';
import supabase from '../../supabaseClient';
import MultiSelectDropdown from './MultiSelectDropdown';

const CTA = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    company: '',
    user_type: '',
    team: '',
    struggles: [],
    otherStruggle: '',
    projectTypes: [],
    otherProjectType: '',
    tools: [],
    otherTool: ''
  });

  const teamOptions = [
    'Individual',
    'Team',
    'Not sure'
  ];

  const userTypeOptions = [
    'Personal',
    'Company',
    'Both',
    'Not sure'
   
  ];
  const toolsOptions = [
    'Notion',
    'Google Workspace',
    'Microsoft Office',
    'Slack',
    'Trello',
    'Jira',
    'Asana',
    'ClickUp',
    'Wrike',
    'Monday',
    'Basecamp',
    'Miro',
    'Airtable',
    'Claude',
    'ChatGPT',
    'DeepSeek',
    'Gemini',
    'Perplexity',
    'Qwen',
    'LLama',
    'Mistral',
    'Cohere',
    'Other'
  ];

  const struggleOptions = [
    'Reducing cognitive load for complex projects',
    'Improving team focus & attention',
    'Breaking down long‑term projects into actionable steps',
    'Maintaining motivation & momentum',
    'Getting real‑time assistance when stuck',
    'Tracking both productivity and well‑being metrics',
    'Ensuring clear alignment & collaboration across teams',
    'Automating personalized time estimates',
    'Celebrating progress with positive reinforcement',
    'Creating immersive focus environments (Pomodoro, music)',
    'Visualizing project endpoints with AI‑generated previews',
    'Supporting neurodivergent workstyles and emotional regulation',
    'Other'
  ];

  const projectTypeOptions = [
    'Software development',
    'Academic research / scientific writing',
    'Design or creative work',
    'Business planning / ops',
    'Personal organization or productivity',
    'Other'
  ];


  // Handle text inputs for first name, last name, email, otherTool, and otherStruggle
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle multiselect changes
  const handleMultiSelectChange = (e, field) => {
    const options = [...e.target.options];
    const selectedValues = options
      .filter(option => option.selected)
      .map(option => option.value);
    
    setFormData(prev => ({
      ...prev,
      [field]: selectedValues
    }));
  };

  // Handle custom multiselect dropdown changes
  const handleCustomMultiSelectChange = (field, selectedValues) => {
    setFormData(prev => ({
      ...prev,
      [field]: selectedValues
    }));
  };

  // Handle other text input changes
  const handleOtherTextChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Submitting form with data:', formData);
    
    try {
      // Process the struggles array:
      let strugglesArray = [...formData.struggles];
      if (strugglesArray.includes('Other')) {
        strugglesArray = strugglesArray.filter(s => s !== 'Other');
        if (formData.otherStruggle.trim() !== '') {
          strugglesArray.push(formData.otherStruggle.trim());
        }
      }

      // Process the project types array:
      let projectTypesArray = [...formData.projectTypes];
      if (projectTypesArray.includes('Other')) {
        projectTypesArray = projectTypesArray.filter(p => p !== 'Other');
        if (formData.otherProjectType.trim() !== '') {
          projectTypesArray.push(formData.otherProjectType.trim());
        }
      }

      // Process the tools array:
      let toolsArray = [...formData.tools];
      if (toolsArray.includes('Other')) {
        toolsArray = toolsArray.filter(t => t !== 'Other');
        if (formData.otherTool.trim() !== '') {
          toolsArray.push(formData.otherTool.trim());
        }
      }
      
      // Insert a single row into the "signups" table:
      const { data, error } = await supabase
        .from('business_signups')
        .insert([{
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          user_type: formData.user_type,
          team: formData.team,
          struggles: formData.struggles,
          projectTypes: formData.projectTypes,
          tools: formData.tools,
        }]);

      if (error) throw error;
  
      console.log('Successfully joined waitlist!', data);
      // Clear the form after success
      setFormData({
        first_name: '',
        last_name: '',
        email: '',
        user_type: '',
        team: '',
        struggles: [],
        otherStruggle: '',
        projectTypes: [],
        otherProjectType: '',
        tools: [],
        otherTool: ''
      });
  
    } catch (error) {
      console.error('Error:', error.message);
      // Optionally, display an error message to the user here
    }
  };



  return (
    <section className="cta" id="cta">
      <div className="cta-container">
        <div className="cta-content">
          <h2>Join the Workspace of the Future</h2>
          <p className="cta-description">
          Get early access to an AI copilot that
           helps you and your team finish projects with clarity and ease. Sign up for:
          </p>
          
          <div className="benefits-grid">
            <div className="benefit-item">
              <img src="/rocket.png" alt="Rocket" className="benefit-icon" />
              <p>Priority Access to Beta</p>
            </div>
            <div className="benefit-item">
              <img src="/flask.png" alt="Flask" className="benefit-icon" />
              <p>Access to<br />Experimental Features</p>
            </div>
            <div className="benefit-item">
              <img src="/map.png" alt="Map" className="benefit-icon" />
              <p>The Opportunity to Influence the Roadmap</p>
            </div>
          </div>

          <div id="waitlist-section" className="waitlist-section">
            <h3>Join the Waitlist Today</h3>
            <p className="waitlist-description">Limited spots available for early access program</p>
            <form onSubmit={handleSubmit} className="enhanced-form">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label" htmlFor="first_name">First Name<span className="required">*</span></label>
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleInputChange}
                    required
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="last_name">Last Name<span className="required">*</span></label>
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleInputChange}
                    required
                    className="form-input"
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label className="form-label" htmlFor="email">Email<span className="required">*</span></label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Are you considering Attenxion for personal use or for a company?<span className="required">*</span></label>
                <div className="select-wrapper">
                  <select
                    className="form-select"
                    name="user_type"
                    value={formData.user_type}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="" disabled className="placeholder-option">Select an option</option>
                    {userTypeOptions.map(user_type => (
                      <option key={user_type} value={user_type}>
                        {user_type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Will you be using Attenxion as an individual or with a team?<span className="required">*</span></label>
                <div className="select-wrapper">
                  <select
                    className="form-select"
                    name="team"
                    value={formData.team}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="" disabled className="placeholder-option">Select an option</option>
                    {teamOptions.map(team => (
                      <option key={team} value={team}>
                        {team}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">What challenges do you most want help with?<span className="required">*</span></label>
                <MultiSelectDropdown
                  options={struggleOptions}
                  selectedValues={formData.struggles}
                  onChange={(selectedValues) => handleCustomMultiSelectChange('struggles', selectedValues)}
                  placeholder="Choose all that apply"
                  required={true}
                  name="struggles"
                  otherValue={formData.otherStruggle}
                  onOtherChange={(value) => handleOtherTextChange('otherStruggle', value)}
                />
              </div>

              <div className="form-group">
                <label className="form-label">What kind of projects do you usually work on?</label>
                <MultiSelectDropdown
                  options={projectTypeOptions}
                  selectedValues={formData.projectTypes}
                  onChange={(selectedValues) => handleCustomMultiSelectChange('projectTypes', selectedValues)}
                  placeholder="Choose all that apply"
                  required={false}
                  name="projectTypes"
                  otherValue={formData.otherProjectType}
                  onOtherChange={(value) => handleOtherTextChange('otherProjectType', value)}
                />
              </div>

              <div className="form-group">
                <label className="form-label">What tools do you currently use to help with projects?</label>
                <MultiSelectDropdown
                  options={toolsOptions}
                  selectedValues={formData.tools}
                  onChange={(selectedValues) => handleCustomMultiSelectChange('tools', selectedValues)}
                  placeholder="Choose all that apply"
                  required={false}
                  name="tools"
                  otherValue={formData.otherTool}
                  onOtherChange={(value) => handleOtherTextChange('otherTool', value)}
                />
              </div>
              
              <button type="submit" className="early-access-button">
                Get Early Access
              </button>
            </form>
            <p className="privacy-notice">
              We respect your privacy. No spam, ever. Unsubscribe anytime.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;

